/**
 * 将 data-track-xxx 属性名转为 camelCase
 */
function kebabToCamel(key) {
  return key.replace(/-([a-z])/g, (_, char) => char.toUpperCase());
}

/**
 * 从 DOM 元素解析 data-track 扩展参数
 */
export function extractTrackParamsFromElement(el) {
  const extra = {};
  const attrs = el.attributes;

  for (let i = 0; i < attrs.length; i++) {
    const attr = attrs[i];
    const name = attr.name;

    if (name === 'data-track' || name === 'data-track-ignore') {
      continue;
    }

    if (name === 'data-track-label') {
      extra.label = attr.value;
      continue;
    }

    if (name === 'data-track-extra') {
      try {
        const parsed = JSON.parse(attr.value);
        if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
          Object.assign(extra, parsed);
        }
      } catch (e) {
        // 忽略非法 JSON
      }
      continue;
    }

    if (name.startsWith('data-track-')) {
      const fieldKey = kebabToCamel(name.slice('data-track-'.length));
      extra[fieldKey] = attr.value;
    }
  }

  return extra;
}

/**
 * 查找最近的带 data-track 的元素
 */
export function findTrackElement(target) {
  let node = target;

  while (node && node !== document.documentElement) {
    if (node.nodeType === 1 && node.hasAttribute('data-track')) {
      return node;
    }
    node = node.parentElement;
  }

  return null;
}

/**
 * 判断元素是否应忽略埋点
 */
export function shouldIgnoreTrackElement(el) {
  if (el.hasAttribute('data-track-ignore')) {
    return true;
  }

  const input = el.closest('input');
  if (input && input.getAttribute('type') === 'password') {
    return true;
  }

  return false;
}

/**
 * 生成会话 ID
 */
export function generateSessionId() {
  return `${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
}

/**
 * 格式化事件时间
 */
export function formatEventTime(date = new Date()) {
  const pad = (n) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
}

/**
 * 是否开启调试日志
 */
export function isTrackDebugEnabled() {
  try {
    return localStorage.getItem('TRACK_DEBUG') === '1';
  } catch (e) {
    return false;
  }
}
